export default [
  {
    title: '包ID',
    key: 'packageId'
  },
  {
    title: 'DMP包名称',
    key: 'dmpName'
  },
  {
    title: '媒体',
    key: 'mediaName'
  },
  {
    title: '推送账号',
    key: 'pushAdAccountName',
    width: 180
  },
  {
    title: '被推送账号',
    key: 'goalAccountName',
    width: 180
  },
  {
    title: '推送人',
    key: 'pushOpName',
    width: 80
  },
  {
    title: '推送时间',
    key: 'pushDate',
    width: 140
  },
  {
    title: '状态',
    key: 'msg',
    width: 220
  },
  {
    title: '操作',
    key: 'control',
    fixed: 'right',
    width: 104
  }
]
